import React, { FC, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { NarrationModel } from '@store/slices/narration.slice'
import { AppDispatch } from '@store/store'
import { AudioSourceType } from '@shared/enums'
import FloatingActionButton from '@components/shared/floatingButton.component'
import { MusicNote } from 'react-bootstrap-icons'
import { generateAudioFromText } from '@store/thunk/audio.thunk'
import { unwrapResult } from '@reduxjs/toolkit'
import { playTmpAudio } from '@shared/tools/audioTools'
import { useNarrationFormContext } from '@components/narration/narration.component'

const TextEditorComponent: FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { setNarrationInEditing, narrationInEditing, source } =
    useNarrationFormContext()
  const editorRef = useRef<HTMLTextAreaElement>(null)

  const handleButtonClick = (selectedText: string) => {
    if (narrationInEditing?.voice) {
      return dispatch(
        generateAudioFromText({
          text: selectedText,
          voiceId: narrationInEditing.voice,
        })
      )
        .then(unwrapResult)
        .then((audioUrl: string) => playTmpAudio(audioUrl))
    }
  }

  const onValueChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value

    if (narrationInEditing) {
      const updatedNarration = {
        ...narrationInEditing,
      }

      if (source === AudioSourceType.TEXT) {
        updatedNarration['text'] = newValue
      } else if (source === AudioSourceType.PHONETIC) {
        updatedNarration['phonetic'] = newValue
      } else {
        throw new Error('Invalid source type for text editor')
      }
      setNarrationInEditing(updatedNarration as NarrationModel)
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      <textarea
        ref={editorRef}
        className={'w-100 overflow-y-scroll'}
        style={{ height: '30rem', maxHeight: '60vh', scrollbarWidth: 'auto' }}
        value={
          source == AudioSourceType.TEXT
            ? narrationInEditing?.text
            : narrationInEditing?.phonetic
        }
        onChange={onValueChange}
      ></textarea>
      <FloatingActionButton
        editorRef={editorRef}
        onClick={handleButtonClick}
        disabled={!narrationInEditing?.voice}
        buttonChild={<MusicNote />}
      />
    </div>
  )
}
export default TextEditorComponent
